import { GuardianService } from './../../_services/guardian.service';
import { Component, OnInit } from '@angular/core';
import { Guardian } from 'src/app/_models/guardian';
declare var $ : any;
@Component({
  selector: 'app-guardian-home-tour',
  templateUrl: './guardian-home-tour.component.html',
  styleUrls: ['./guardian-home-tour.component.css']
})
export class GuardianHomeTourComponent implements OnInit {
  guardian= new Guardian()
  constructor(private guardianService:GuardianService) { }

  ngOnInit(): void {
    this.guardianService.guardianSubject.subscribe(
      x=>{
        this.guardian=x
      }
    )
  }
  addStudentRegistrationPopup(){
    $("#regStudentModal").modal("show");
  }
}
